<template lang="html">
  <section class="auth-section">
    <!-- TODO: DRY: Move common code from login/join/password_reset etc here -->
    <router-view class="auth-section-inner"></router-view>
  </section>
</template>

<script>
export default {
  name: 'Auth',
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/app-width';
@import '@/styles/mixins/block-form';
@import '@/styles/mixins/auth-form';

.auth-section {
  justify-content: center;
  display: flex;
}

::v-deep .auth-section-inner {
  @include app-width;
  @include block-form;
  @include auth-form;

  flex-grow: 1;
}
</style>
